module.exports = "../../../../platform/assets/pageMainIcon/simple_yewuchulilei4.svg";